import { MapPin, Navigation } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { SectionHeading } from "../components/SectionHeading";
import { BUSINESS, SHOWROOM } from "../data/content";
import { scrollToId } from "../lib/scroll";

export const Showroom = () => (
  <section id="showroom" data-testid="showroom-section" className="py-20 md:py-32 bg-royal-deep relative grain overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 md:px-8 relative">
      <div className="grid md:grid-cols-12 gap-12 items-center">
        <div className="md:col-span-5">
          <SectionHeading chapter="08" overline="The Showroom" title={SHOWROOM.title} dark />
          <Reveal className="-mt-6 md:-mt-10">
            <p className="text-base md:text-lg font-light text-ivory/70 leading-relaxed">{SHOWROOM.text}</p>
            <div className="mt-9 flex flex-wrap gap-3.5">
              <a
                data-testid="showroom-directions-button"
                href={BUSINESS.mapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="px-7 py-3.5 bg-gold text-royal-deep text-sm tracking-[0.12em] uppercase font-medium rounded-sm hover:bg-gold-light transition-colors duration-300 flex items-center gap-2"
              >
                <Navigation size={15} strokeWidth={1.5} /> Get Directions
              </a>
              <button
                data-testid="showroom-visit-button"
                onClick={() => scrollToId("contact")}
                className="px-7 py-3.5 border border-ivory/40 text-ivory text-sm tracking-[0.12em] uppercase font-medium rounded-sm hover:bg-ivory hover:text-royal-deep transition-colors duration-300 flex items-center gap-2"
              >
                <MapPin size={15} strokeWidth={1.5} /> Visit Our Store
              </button>
            </div>
          </Reveal>
        </div>

        <div className="md:col-span-7">
          <div className="grid grid-cols-2 gap-4">
            <Reveal className="col-span-2">
              <div className="relative overflow-hidden rounded-sm group">
                <img
                  src={SHOWROOM.images[0].image}
                  alt={SHOWROOM.images[0].alt}
                  loading="lazy"
                  className="w-full h-[280px] md:h-[360px] object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
                />
                <span className="absolute bottom-4 left-4 text-[11px] tracking-[0.25em] uppercase text-ivory/90 bg-royal-deep/60 backdrop-blur-sm px-3.5 py-1.5 rounded-sm">
                  {SHOWROOM.images[0].label}
                </span>
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="relative overflow-hidden rounded-sm group">
                <img
                  src={SHOWROOM.images[1].image}
                  alt={SHOWROOM.images[1].alt}
                  loading="lazy"
                  className="w-full h-[180px] md:h-[220px] object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
                />
                <span className="absolute bottom-3 left-3 text-[10px] tracking-[0.25em] uppercase text-ivory/90 bg-royal-deep/60 backdrop-blur-sm px-3 py-1.5 rounded-sm">
                  {SHOWROOM.images[1].label}
                </span>
              </div>
            </Reveal>
            <Reveal delay={0.18}>
              <div className="relative overflow-hidden rounded-sm group h-[180px] md:h-[220px]">
                <video
                  data-testid="showroom-video"
                  autoPlay
                  muted
                  loop
                  playsInline
                  preload="metadata"
                  poster="/showroom/showroom-poster.jpg"
                  className="w-full h-full object-cover"
                  aria-label="Jeweller Kalika Prasad showroom film"
                >
                  <source src="/showroom/showroom-video.mp4" type="video/mp4" />
                  <source src="/showroom/showroom-video.webm" type="video/webm" />
                </video>
                <span className="absolute bottom-3 left-3 text-[10px] tracking-[0.25em] uppercase text-ivory/90 bg-royal-deep/60 backdrop-blur-sm px-3 py-1.5 rounded-sm">
                  Showroom Film
                </span>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </div>
  </section>
);
